import { UserJobOpeningResponse } from "../../pages/userRecruiting/interface";
import { adminApiRequest, apiRequest } from "../../utils/apiUtils";

export interface UserJobReportResponse {
  id: number;
  job: UserJobOpeningResponse;
  complete: boolean;
  delete: boolean;
  reportNickname: string;
  type: string;
  description: string;
  createdAt: string;
}

export const UserJobOpeningAPI = {
  getUserJobOpening: () => {
    return adminApiRequest
      .get("/job-opening/user/list")
      .then((res) => res.data);
  },
  registerUserJobOpening: (body: any) => {
    return adminApiRequest
      .post("/job-opening/user/register", body)
      .then((res) => res);
  },
  updateUserJobOpening: (body: any) => {
    return adminApiRequest
      .put("/job-opening/user/update", body)
      .then((res) => res);
  },
  deleteUserJobOpening: (id: number) => {
    return adminApiRequest
      .delete(`/job-opening/user/delete/${id}`)
      .then((res) => res);
  },
  getJobReport: () => {
    return adminApiRequest
      .get("/job-opening/user/report")
      .then((res) => res.data);
  },
  removeUserJobReport: (id: number) => {
    return adminApiRequest
      .delete(`/job-opening/user/report/${id}`)
      .then((res) => res);
  },
  acceptUserJobReport: (id: number) => {
    return adminApiRequest
      .put(`/job-opening/user/report/${id}`)
      .then((res) => res);
  },
};

export const jobOpeningApi = {
  getJobOpening: () =>
    apiRequest<any>("post", "/admin/job-opening/list", {
      data: { lat: "0", lon: "0" },
      fullResponse: true,
    }),
  removeJobOpening: (id: number) =>
    apiRequest<any>("delete", `/admin/job-opening/delete/${id}`, {
      fullResponse: true,
    }),
  saveJobOpening: (body: any) =>
    apiRequest<any>("put", "/admin/job-opening/update", {
      data: body,
      fullResponse: true,
    }),
  addJobOpening: (body: any) =>
    apiRequest<any>("post", "/admin/job-opening/register", {
      data: body,
      fullResponse: true,
    }),
};

